import { DictionaryType } from '../../../models/types/dictionary.type';
import { ModelTypes } from './model.types';

export class ServerRouteMapper {
    static get apiRoutesByType(): DictionaryType<string> {
        const dict: DictionaryType<string> = {};

        dict[ModelTypes.shareholders] = '/shareholders';
        dict[ModelTypes.shareholdersSummary] = '/shareholders';
        dict[ModelTypes.gmShareholdersSummary] = '/general-meetings/current/shareholders';
        dict[ModelTypes.traders] = '/traders';
        dict[ModelTypes.tradersSummary] = '/traders';
        dict[ModelTypes.transactions] = '/transactions';
        dict[ModelTypes.transactionsSummary] = '/transactions';
        dict[ModelTypes.users] = '/users';

        return dict;
    }
}
